/*eslint-disable*/ module.exports = { messages: { Settings: 'xxx' } }
